export default "__VITE_ASSET__CXZjMDyR__"